import Activity from "./analytics/activity";
import BarGraph from "./analytics/bargraph";
import Expenses from "./analytics/expenses";
import ListChart from "./analytics/list";
import PieChart from "./analytics/piechart";

const Analytics = () => {
    return (
        <>

            <div className="row">
                <Activity/>
                <Expenses/>
                <BarGraph/>
                <ListChart/>
                <PieChart/>
            </div>
        </>
    );
}

export default Analytics;